<div class="rs-panel-big rs-bg-c2">
  <ng-container *ngFor="let odbBillProductSplit of productSplit">
    <ng-container *ngIf="odbBillProductSplit.categoryDetails">
      <ng-container
        *ngFor="let categoryDetails of odbBillProductSplit.categoryDetails"
      >
        <ng-container
          *ngFor="let section of categoryDetails.sections; let last = last"
        >
          <div class="rs-flex-row">
            <div class="rs-flex-column">
              <p class="rs-txt-primary">
                <span class="rs-txt-details"
                  >{{ section.vatRate ? section.vatRate : ''
                  }}{{
                    (section.vatRate
                      ? 'bills.cover.odbDetails.vatPercentOn'
                      : 'bills.cover.odbDetails.noVatOn'
                    ) | translate
                  }} </span
                ><strong *ngIf="section.amountExclVAT"
                  ><px-currency-amount
                    [amount]="section.amountExclVAT"
                  ></px-currency-amount
                ></strong>
              </p>
            </div>
            <div
              class="rs-flex-column rs-flex-shrink"
              *ngIf="section.vatRate && section.vatAmount"
            >
              <p class="rs-font-pxB">
                <px-currency-amount
                  [amount]="section.vatAmount"
                ></px-currency-amount>
              </p>
            </div>
          </div>
          <hr *ngIf="!last" />
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
<!-- TOTAL -->
<div
  class="panel rs-bg-primary rs-margin-bottom2-s rs-margin-bottom4-m"
  my-bill-odb-total
  [amount]="totalAmount"
  [attr.data-cy]="'vat_total'"
></div>
